import { Box, Text } from "@chakra-ui/react";
import {
  EhrName,
  EhrProvider,
  EhrWriteParams,
  PatientOverview,
  PatientOverviewV2,
  SharedStateProvider,
} from "@metriport/shared-internal";
import { ossBaseUrlCanvas } from "../../../api/api";
import {
  getResourceDiffJob,
  startResourceDiffJob,
  writeResourceToChart,
} from "../../../api/ehr/canvas";
import { useAppContext } from "../../contexts/app/index";
import useMetriportToast from "../../shared/toast";

export default function PatientPage() {
  const { state } = useAppContext();
  const toast = useMetriportToast();

  if (!state.isLoaded) {
    return null;
  }

  const ehrDetails = {
    ehrPatientId: state.ehrPatientId,
    write: async (params: EhrWriteParams) => {
      if (!state.ehrPractitionerId) {
        toast.warning({
          title:
            "Practitioner ID is required. Please update your Canvas plug-in to 0.0.3 or later. If the problem persists, please reach out to support@metriport.com",
        });
        return;
      }
      await writeResourceToChart({
        ...params,
        practitionerId: state.ehrPractitionerId,
      });
    },
    diff: {
      startResourceDiffJob,
      getResourceDiffJob,
    },
    name: EhrName.Canvas,
  };

  return (
    <Box>
      {state.ehrPatientId ? (
        <SharedStateProvider
          authToken={state.authToken}
          baseUrl={ossBaseUrlCanvas}
          ehrDetails={ehrDetails}
          featureFlags={state.featureFlags}
        >
          {state.featureFlags.shouldShowLegacyDashV1 ? (
            <PatientOverview patientId={state.ehrPatientId} />
          ) : (
            // after v1 code is removed, remove ehrDetails from SharedStateProvider ^!
            <EhrProvider patientId={state.ehrPatientId} ehrDetails={ehrDetails}>
              <PatientOverviewV2 patientId={state.ehrPatientId} />
            </EhrProvider>
          )}
        </SharedStateProvider>
      ) : (
        <Text>No Patient</Text>
      )}
    </Box>
  );
}
